import { useMemo, useState } from "react";
import FilmCard from "@/components/base/FilmCard";
import SectionHeading from "@/components/base/SectionHeading";
import { newestFilms } from "@/lib/films";
import type { Film } from "@/types/film";

type TabKey = "all" | "movie" | "tv";

const tabs: { key: TabKey; label: string }[] = [
  { key: "all", label: "全部" },
  { key: "movie", label: "电影" },
  { key: "tv", label: "电视剧" },
];

export default function LatestGrid() {
  const [tab, setTab] = useState<TabKey>("all");
  const list: Film[] = useMemo(() => {
    if (tab === "all") return newestFilms(12);
    return newestFilms(12, tab);
  }, [tab]);

  return (
    <section className="container-portal mt-12 md:mt-16">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <SectionHeading
          kicker="New Releases"
          title="最新影视资讯"
          description="按上线时间整理的院线新片与热播剧集，点击卡片查看完整剧情与演员资料。"
        />
        <div className="flex shrink-0 items-center gap-1 rounded-full border border-background-200 bg-background-100 p-1">
          {tabs.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => setTab(item.key)}
              className={[
                "rounded-full px-3.5 py-1.5 text-xs font-medium transition-colors cursor-pointer whitespace-nowrap",
                tab === item.key
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-primary-600",
              ].join(" ")}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-7 grid grid-cols-2 gap-x-3 gap-y-7 sm:grid-cols-3 sm:gap-x-4 lg:grid-cols-6">
        {list.map((film) => (
          <FilmCard key={film.id} film={film} showType={tab === "all"} />
        ))}
      </div>
    </section>
  );
}